import jquery from 'jquery';
import React from 'react';
import { message, Table, Popconfirm, Button } from 'antd';
import API_URL from '../../common/url';
import AjaxRequest from '../../common/AjaxRequest';
import AddReport from './AddReport';
import UserSider from './UserSider';
import ExportUtil from '../../common/ExportUtil';
import SearchRetrieve from '../common/SearchRetrieve.new.js';
import { connect } from 'react-redux';
import { saveParams } from '../../actions/noticeActions';

const initState = {
    sortParams: {},
    searchParams: {
        userId: '',
        leaderId: ''
    },
    data: [],
    loading: false,
    addStatus: false,
    pagination: {
        pageSize: 10,
        current: 1,
    },
    dataList: [],
}

class InvContractRelated extends React.Component {
    state = initState;

    loadData = (params = {}) => {
        this.setState({ loading: true });
        const { searchParams, pagination } = this.state;
        const options = {
            url: `${API_URL.user.listVirtualReportLine}`,
            data: {
                offset: pagination.current,
                ...params,
                ...searchParams,
                limit: pagination.pageSize,
            },
            dataType: 'json',
            doneResult: (data => {
                const pagination = { ...this.state.pagination };
                pagination.total = data.totalCount;
                this.setState({
                    loading: false,
                    dataList: data.datas,
                    pagination,
                });

                if ((searchParams.offset && searchParams.offset) > 1 || pagination.current > 1) {
                    const dataList = data.datas || [];
                    if (data.datas.length == 0) {
                        this.reload({}, '', true);
                    }
                }
            }),
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        AjaxRequest.sendRequest(options);
    }

    componentDidMount() {
        const { params = {} } = this.props;
        const { employeeCode, leaderEmployeeCode, userId, name, leaderId, leaderName } = params;
        this.setState({
            searchParams: {
                userId: userId?userId:'',
                leaderId: leaderId?leaderId:'',
                userName: name?`${name}[${employeeCode}]`:undefined,
                leaderName: leaderName?`${leaderName}[${leaderEmployeeCode}]`:undefined,
            },
        }, () => {
            this.loadData();
        })
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            searchParams: {
                userId: '',
                leaderId: ''
            },
        });
    }

    getColumns = () => {
        const columns = [{
            title: '汇报者工号',
            dataIndex: 'employeeCode',
            key: 'employeeCode',
            render: (text, record) => {
                return record.workStatus == 'LEFT' ? <span style={{ color: '#999999' }}>{text}</span> : text;
            },
        }, {
            title: '汇报者姓名',
            dataIndex: 'name',
            key: 'name',
            render: (text, record) => {
                return record.workStatus == 'LEFT' ? <span style={{ color: '#999999' }}>{text}</span> : text;
            },
        }, {
            title: '汇报对象工号',
            dataIndex: 'leaderEmployeeCode',
            key: 'leaderEmployeeCode',
            render: (text, record) => {
                return record.leaderWorkStatus == 'LEFT' ? <span style={{ color: '#999999' }}>{text}</span> : text;
            },
        }, {
            title: '汇报对象姓名',
            dataIndex: 'leaderName',
            key: 'leaderName',
            render: (text, record) => {
                return record.leaderWorkStatus == 'LEFT' ? <span style={{ color: '#999999' }}>{text}</span> : text;
            },
        }];
        columns.push({
            title: '操作',
            width: 80,
            render: (text, record) => {
                return (
                    <Popconfirm title={'确定要删除吗?'} onConfirm={this.del.bind(this, record)} okText="确定" cancelText="取消">
                        <a>删除</a>
                    </Popconfirm>
                );
            },
        });
        return columns;
    }

    getDataSource = () => {
        const records = [];
        const { dataList, pagination } = this.state;
        dataList.map((dataItem, i) => {
            records.push({
                key: dataItem.questionCategoryId,
                ...dataItem,
                index: ((pagination.current - 1) || 0) * 15 + i + 1,
            });
        });
        return records;
    }

    handleTableChange = (pagination, filters, sorter) => {
        let sortType,
            direction,
            sort = sort = sorter.field;
        const pager = { ...this.state.pagination };
        if (pager.current == pagination.current) {
            pager.current = 1;
            //排序则页码为1
        } else {
            pager.current = pagination.current;
            //获取当前页
        }
        if (!jquery.isEmptyObject(sorter) && sorter.column) {
            sortType = sorter.column.sortType;
        }
        if (sorter.order === 'descend') {
            direction = 'DESC';
        } else {
            direction = 'ASC';
        }
        this.setState({
            pagination: pager,//设置新的分页信息
            sortParams: {//设置排序信息
                direction,
                sort,
                sortType
            }
        });

        this.loadData({
            limit: pager.pageSize,
            offset: pager.current,
            direction,
            sort,
            sortType,
            ...this.state.searchParams,
            ...filters,
        });
    }

    reload = (params = {}, type, pre) => {
        const newParams = {};
        if (type == "search") {
            newParams.searchParams = params;
            newParams.pagination = { ...this.state.pagination, current: 1 };
        }
        this.setState({
            ...newParams
        }, () => {
            const { pagination, searchParams, sortParams } = this.state;
            this.loadData({
                offset: (!pre && pagination.current > 1) ? pagination.current : pagination.current - 1,
                ...sortParams,
                ...searchParams,
            });
        })
    }

    search = () => {
        const { searchParams, keyword } = this.state;
        const newSearch = {
            ...searchParams,
            keyword
        };
        this.setState({
            searchParams: newSearch
        }, () => {
            this.reload(newSearch, "search");
        });
    }

    export = () => {
        const { searchParams, pagination } = this.state;
        let url = API_URL.user.exportVirtualReportLine;
        ExportUtil.export(searchParams, pagination, url);
    }

    addReport = () => {
        this.AddReport.show("add");
    }
    
    del = (record = {}) => {
        const { userLeaderId } = record;
        this.setState({ loading: true });
        const options = {
            url: `${API_URL.user.deleteVirtualReportLine}`,
            data: {
                userleaderId: userLeaderId
            },
            dataType: 'json',
            doneResult: () => {
                message.success("删除成功");
                this.setState({ loading: false }, () => {
                    this.reload();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        AjaxRequest.sendRequest(options);
    }

    handleChange = (option, key) => {
        const { searchParams } = this.state;
        const { text, value } = option;
        if (key === 'user') {
            searchParams.userId = value;
            searchParams.userName = text;
        } else if (key === 'leader') {
            searchParams.leaderId = value;
            searchParams.leaderName = text;
        }
        this.setState({ searchParams });
    }

    render() {
        const { loading, pagination, searchParams } = this.state;
        const { userName, leaderName } = searchParams;
        return (
            <div className="content">
                <UserSider selectKey='dashedReport' openKeys={['sub1']}/>
                <div className="main">
                    <div className="filter-bar bar2">
                        <div className="form-item">
                            <label className="ui-label">汇报者</label>
                            <SearchRetrieve
                                keyword='keyWord'
                                style={{ width: 132 }}
                                value={userName}
                                params={{ limit: 20, needPosition: 'TRUE' }}
                                placeholder="输入姓名/工号检索"
                                url={API_URL.team.queryEmpListByRoleCode}
                                config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                                onChange={option => this.handleChange(option, 'user')}
                            />
                        </div>
                        <div className="form-item">
                            <label className="ui-label">汇报对象</label>
                            <SearchRetrieve
                                keyword='keyWord'
                                style={{ width: 132 }}
                                value={leaderName}
                                params={{ limit: 20, needPosition: 'TRUE' }}
                                placeholder="输入姓名/工号检索"
                                url={API_URL.team.queryEmpListByRoleCode}
                                config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                                onChange={option => this.handleChange(option, 'leader')}
                            />
                        </div>
                        <div className="btn" style={{ float: 'right' }}>
                            <Button type="primary" onClick={this.export}>导出</Button>
                            <Button type="primary" onClick={this.addReport}>添加</Button>
                            <Button type="primary" onClick={this.search}>搜索</Button>

                        </div>
                    </div>
                    <Table
                        columns={this.getColumns()}
                        dataSource={this.getDataSource()}
                        rowKey={record => record.index + record.employeeCode}
                        loading={loading}
                        pagination={pagination}
                        onChange={this.handleTableChange}
                    />
                    <AddReport
                        ref={el => this.AddReport = el}
                        loadData={this.reload}
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state, props) => {
    return {
        params: state.noticeState.params,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        saveParams: (params) => dispatch(saveParams(params)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(InvContractRelated);


// WEBPACK FOOTER //
// ./src/components/user/DashedReport.js